import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  useEffect(() => {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  }, [user]);

  const login = (role, username) => {
    const userData = {
      role,
      username: username || getRoleUsername(role),
      name: getRoleName(role),
    };
    setUser(userData);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  const getRoleUsername = (role) => {
    const usernames = {
      facilityManager: 'manager',
      maintenanceTechnician: 'technician',
      safetyOfficer: 'safety',
      management: 'executive',
    };
    return usernames[role] || 'user';
  };

  const getRoleName = (role) => {
    const names = {
      facilityManager: 'Jan Novák',
      maintenanceTechnician: 'Petr Svoboda',
      safetyOfficer: 'Marie Dvořáková',
      management: 'Ing. Karel Černý',
    };
    return names[role] || 'User';
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
